import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SubmitAssessment(assessmentId, commandId) {
  const response = await $.soap({
    body: {
      SubmitAssessment: {
        $xmlns: 'http://dla.mil/ems/bpm/assessment',
        AssessmentID: assessmentId,
        CommandID: commandId
      }
    },
    blueprint: {
      assessment: '$..CustomerAssessment'
    }
  });

  cleanUpResponse(response);
  return response.assessment;
}
